import { render, staticRenderFns } from "./ManutenzioneRadialMenu.vue?vue&type=template&id=81c5e1a8&scoped=true&"
import script from "./ManutenzioneRadialMenu.js?vue&type=script&lang=js&"
export * from "./ManutenzioneRadialMenu.js?vue&type=script&lang=js&"
import style0 from "./ManutenzioneRadialMenu.css?vue&type=style&index=0&id=81c5e1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c5e1a8",
  null
  
)

export default component.exports